<template>
  <div class="card" :class="!show_content ? 'card_pb10' : ''">
    <div class="header" @click="show_this_block()">
      <div class="title" :title="translate('rssi')">
        RSSI
        <span>
          ( {{ show_block ? translate('click_to_hide') : translate('click_to_show') }} )
        </span>
      </div>
    </div>
    <div class="content" :class="{ show_content: show_content }" v-on:wheel="wheel" v-if="show_content">
      <div class="spinner_charts" v-if="!show_chart">
        <scale-loader style="position: relative; padding-top: 10%" />
      </div>
      <div class="echarts" v-else>
        <IEcharts
          v-if='show_content'
          :option="option"
          @ready="onReady"
        />
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'RssiChart',
  props: ['params', 'show_block', 'today'],

  data () {
    // const that = this
    return {
      ins: null,
      echarts: null,
      load: true,
      show: false,
      data: [],

      main_data: {
        time: [],
        sim: {}
      },

      show_content: false,
      show_chart: false
    }
  },

  mounted() {
    this.show_content = this.show_block
    this.init_req()
  },

  computed: {
    info(){
      return this.main_data
    },
    loader(){
      return this.status
    },
    time () {
      return this.info.time.map(this.translate_of_time)
    },
    legend_data () {
      let legend = []
      for (let i in this.info.sim) {
        legend.push(i)
      }
      return legend
    },

    series_data () {
      let series = []
      let temp = {}

      for (let i in this.legend_data) {
        temp = {
          name: this.legend_data[i],
          type: 'line',
          symbolSize: 8,
          hoverAnimation: false
        }
        temp.data = this.info.data[this.legend_data[i]]
        temp.xAxisIndex = 0
        temp.yAxisIndex = 0
        series.push(temp)
      }
      return series
    },

    option () {
      return {
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              title: this.translate('save'),
              type: 'png',
              pixelRatio: 5
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            animation: false
          },
          formatter: function (series) {
            let axisIndex0 = 'rssi:<br/>'
            let template = series[0].name + '<br/>'
            for (let i in series) {
              if (series[i].axisIndex === 0) {
                axisIndex0 += series[i].marker + this.info.sim[series[i].seriesName].mno + ((this.info.sim[series[i].seriesName].slot !== undefined) ? '(' + this.info.sim[series[i].seriesName].slot + ')' : '') + ':' + (series[i].value ? series[i].value : 0) + '<br/>'
              }
            }
            template += axisIndex0
            return template
          }.bind(this)
        },
        legend: {
          type: 'scroll',
          itemGap: 10,
          itemHeight: 10,
          y: 30,
          // data: this.legend_data,
          formatter: function (imsi) {
            return this.info.sim[imsi].mno + ((this.info.sim[imsi].slot !== undefined && this.info.sim[imsi].slot !== null) ? '(' + this.info.sim[imsi].slot + ')' : '')
          }.bind(this),
          left: 'right'
        },
        axisPointer: {
          link: {xAxisIndex: 'all'}
        },
        dataZoom: [
          {
            show: true,
            realtime: false,
            start: 0,
            end: 100,
            xAxisIndex: [0, 0],
            type: 'slider',
            preventDefaultMouseMove: true,
            zoomOnMouseWheel: 'shift',
            bottom: '5%'
          }
        ],
        grid: [{
          y: '25%',
          left: 90,
          right: 35,
          height: '50%'
        }],
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLine: {onZero: true},
            data: this.time
          }
        ],
        yAxis: [
          {
            gridIndex: 0,
            name: 'rssi (dBm)',
            type: 'value'
          }
        ],
        series: this.data
      }
    }
  },
  watch: {
    resize () {
      if (this.ins !== undefined) {
        this.ins.resize()
      }
    },

    info () {
      if (Object.keys(this.info).length !== 0) {
        this.load = false
      } else {
        this.load = true
      }

    }

  },
  methods: {
    init_req(){
      if (this.show_content){
        this.show_chart = false
        this.$http.v1.getDeviceRSSI(this.params, (response) => {
          this.main_data = response.data
          this.show_chart = true
        })
      } else{
        this.main_data = {
          category: [],
          data: []
        }
      }
    },
    translate_of_time(unixTime){
      let options = {}
      if (this.today) {
        options = {
          hour12: false,
          hour: '2-digit',
          minute: '2-digit'
        }
      }else{
        options = {
          hour12: false,
          hour: '2-digit',
          minute: '2-digit',
          day: '2-digit',
          month: '2-digit'
        }
      }
      return this.get_date(unixTime, options)
    },
    show_this_block(){
      this.$emit('show_rssi')
      this.show_content = !this.show_content
      this.init_req()
    },
    wheel (event) {
      if (event.shiftKey) {

        let start = this.ins.getOption().dataZoom[0].start + event.zrDelta * 2
        let end = this.ins.getOption().dataZoom[0].end - event.zrDelta * 2
        if(start < 0 || end > 100 || start > end || end < start || (end - start <= 0) ) {
          return false
        }
        this.ins.dispatchAction({
          type: 'dataZoom',
          start: start,
          end: end,
        })
      }
    },
    onReady (instance, echarts) {
      const that = this
      that.ins = instance
      that.echarts = echarts
      that.timer = null

      this.load = true;
      setTimeout( () => { this.data = this.series_data; this.show = true }, 50)
      that.ins.on('finished',() => { if(this.show == true) { this.load = false; this.$emit('finished',1) }})

      const updatePosition = function () {
        clearTimeout(that.timer)

        that.timer = setTimeout(() => {
          if (that.ins.resize !== undefined || that.ins.resize !== null) {
            that.ins.resize()
          }
        }, 200)
      }
      window.addEventListener('resize', updatePosition)
    }
  }
}
</script>
<style lang="scss" scoped>
  .card{
    padding: 10px 10px 0;
    overflow: hidden;
    &.card_pb10{
      padding-bottom: 10px;
    }
    .header{
      padding: 10px 0;
      cursor: pointer;
      .title{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        span{
          color: #999;
          font-size: 14px;
          font-weight: 600;
          margin-left: 5px;
        }
      }
    }
    .content{
      transition: 0.3s;
      padding: 0 0 10px;
      opacity: 1;
      height: auto;
      &.hide_block{
        opacity: 0;
        height: 0;
        padding: 0;
      }
      .echarts{
        width: 99%;
        height: 310px;
      }
    }
  }
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>
